/**
 * !WARNING: for ORGANIZATION partner usage.
 */

import debounce from 'lodash.debounce';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { updatePartner, updatePartnerForm } from '../../features/organization-form/slice';
import { subAdapter } from '../../features/organization-form/adapter';
import { PartnerExternal } from './partner-form-external';
import service from '../../features/organizations/service';
import { blobToFile, errorHandler } from '../../utils';
import { toast } from 'react-toastify';

const PartnerFormEdit = ({ defaultValue = {}, setIsEdit, noImage }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const form = useSelector(state => state.organizationForm.partner.form)
  const { partners_external } = useSelector(state => state.organizationForm.partner)

  useEffect(() => {
    if(defaultValue && Object.keys(defaultValue).length > 0){
      for (let index = 0; index < Object.keys(defaultValue).length; index++) {
        const key = Object.keys(defaultValue)[index];
        dispatch(updatePartnerForm({key, value: defaultValue[key]}))
      }
    }
  }, [dispatch, defaultValue])

  const handleInput = debounce((e) => {
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updatePartnerForm({key, value}))
    }
  }, 250)

  const handleImage = (e) => {
    if(e && e.type){
      dispatch(updatePartnerForm({
        key: 'new_image',
        value: {
          blob: URL.createObjectURL(e),
          name: e.name,
          type: e.type
        }
      }))
    }
  }

  const handleCancel = (e) => {
    history.push('/dashboard/organization/profile/partners')
  }

  const handleSave = async () => {
    if(form.pkId){
      const promises = []

      const requestBody = subAdapter.partner.external.formToRequestBody(form)
      const promise1 = await service.updatePartnerExternal(form.pkId, requestBody)
      promises.push(promise1)

      const needToUpdateImage = form.new_image && form.new_image.blob
      if(needToUpdateImage){
        let newImage
        let formData = new FormData()

        newImage = await blobToFile(form.new_image.blob, form.new_image.name, form.new_image.type)
        formData.append('imgLogoPartner', newImage)

        const requestBodyFile = newImage ? formData : false
        const promise2 = await service.updatePartnerExternal(form.pkId, requestBodyFile)
        promises.push(promise2)
      }

      return Promise.all(promises)
        .then((res) => {
          console.log(res)
          toast.success('Partner successfully updated!')
          history.push('/dashboard/organization/profile/partners')
        })
        .catch(err => {
          console.log({err})
          const msg = errorHandler(err)
          toast.error(msg)
        })
    } else {
      // Edit local external partner
      console.log({form})
      if(setIsEdit && typeof setIsEdit === 'function'){
        setIsEdit(false)

        const newPartnersExternal = []

        for (let index = 0; index < partners_external.length; index++) {
          const element = partners_external[index];
          if(element.id === form.id){
            newPartnersExternal.push(form)
          } else {
            newPartnersExternal.push(element)
          }
        }

        dispatch(updatePartner({
          key: 'partners_external',
          value: newPartnersExternal
        }))
      }
    }
  }

  return (
    <div className="lg:w-3/4">
      <PartnerExternal
        noImage={noImage}
        defaultValue={defaultValue}
        handleImage={handleImage}
        handleCancel={handleCancel}
        handleSave={handleSave}
        updateForm={e => {e.persist(); handleInput(e)}}
      />
    </div>
  )
}

export { PartnerFormEdit }
